module.exports={BACK:"BACK",FINISH:"FINISH",NEXT:"NEXT",CHAIN:"CURRENCY SELECTION",WALLET:"SEND FUNDS",NEW_TOPUP:"Deposit cryptocurrency into wallet"};